/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Radio, Space, Checkbox, Button } from 'antd';
import parse from 'html-react-parser';
import IconNoData from '../../../../../assets/Images/icons/icon-no-data';
import { toBuddhistYear } from '../../../../../util/util';
import moment from 'moment';
import 'moment/locale/th';

const ConsentPreview = ({
    previewLang,
    templateDetail,
    logoCompany,
    masterConsent,
}) => {
    const [form] = Form.useForm();
    const [, forceUpdate] = useState({});
    const getConsent = (id) => {
        return masterConsent?.find((element) => {
            return id === element?.consentTxnGroupId;
        });
    };

    useEffect(() => {
        forceUpdate({});
    }, []);

    useEffect(() => {
        form.resetFields();
    }, [templateDetail]);

    return (
        <>
            {templateDetail ? (
                <Form form={form} layout="vertical">
                    <div className="bg-white rounded-md whitespace-pre-line border-solid border-[#ECECEC] p-6 mt-2 leading-7 overflow-auto max-h-[700px]">
                        <div className="text-center">
                            <div
                                className="text-center my-4 justify-center"
                                hidden={!logoCompany}
                            >
                                <img
                                    src={logoCompany}
                                    className="object-cover w-auto h-20"
                                    alt={
                                        previewLang === 'en' ? 'Logo' : 'โลโก้'
                                    }
                                />
                            </div>
                        </div>
                        <div
                            className="text-center text-xl font-semibold whitespace-pre-wrap"
                            style={{ wordBreak: 'break-word' }}
                        >
                            {previewLang === 'en'
                                ? parse(templateDetail?.titleEn || '-')
                                : parse(templateDetail?.titleTh || '-')}
                        </div>
                        <div
                            className="my-2"
                            style={{ borderBottom: '1px solid #EDEEF9' }}
                        ></div>
                        <div className="text-sm font-semibold whitespace-pre-wrap mb-4">
                            {previewLang === 'en'
                                ? parse(templateDetail?.templateNameEn || '-')
                                : parse(templateDetail?.templateNameTh || '-')}
                        </div>

                        {templateDetail?.templateDesignIdentity
                            ?.map((item, index) => {
                                return (
                                    <Form.Item
                                        name={['new_item', index]}
                                        className="w-full"
                                        key={index}
                                        label={
                                            previewLang === 'th'
                                                ? item?.labelNameTh
                                                : item?.labelNameEn
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    previewLang === 'en'
                                                        ? 'This field is required.'
                                                        : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            maxLength={50}
                                            showCount
                                        />
                                    </Form.Item>
                                );
                            })
                            .sort((a, b) => a.sequence - b.sequence)}

                        <div className="text-sm font-base whitespace-pre-wrap indent-12">
                            {previewLang === 'en'
                                ? parse(templateDetail?.firstParagraphEn || '-')
                                : parse(
                                      templateDetail?.firstParagraphTh || '-'
                                  )}
                        </div>

                        {templateDetail?.consentForms?.map((item, index) =>
                            item.noteId ? (
                                parse(
                                    previewLang === 'en'
                                        ? item.titleEn
                                        : item.titleTh || ''
                                )
                            ) : (
                                <div className="mt-2" key={index}>
                                    <div className="text-sm font-semibold whitespace-pre-wrap">
                                        {previewLang === 'en'
                                            ? parse(
                                                  getConsent(
                                                      item?.consentTxnGroupId
                                                  )?.consentNameEn || '-'
                                              )
                                            : parse(
                                                  getConsent(
                                                      item?.consentTxnGroupId
                                                  )?.consentNameTh || '-'
                                              )}
                                    </div>
                                    <div className="text-sm font-base whitespace-pre-wrap">
                                        {previewLang === 'en'
                                            ? parse(
                                                  getConsent(
                                                      item?.consentTxnGroupId
                                                  )?.purposeEn || '-'
                                              )
                                            : parse(
                                                  getConsent(
                                                      item?.consentTxnGroupId
                                                  )?.purposeTh || '-'
                                              )}
                                    </div>
                                    {getConsent(item?.consentTxnGroupId)
                                        ?.isConsented ? (
                                        <Form.Item
                                            className="initial mb-2"
                                            name={item?.consentTxnGroupId}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        previewLang === 'en'
                                                            ? 'This field is required.'
                                                            : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                                },
                                            ]}
                                        >
                                            <Checkbox.Group size="large">
                                                <Space direction="vertical">
                                                    <Checkbox
                                                        className={`bg-[#F4F6FC] rounded-lg px-4 py-2`}
                                                        key={`${item.sequence}_Accept`}
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        value={true}
                                                    >
                                                        {previewLang === 'en'
                                                            ? 'Acknowledge'
                                                            : 'รับทราบ'}
                                                    </Checkbox>
                                                </Space>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    ) : (
                                        <Form.Item
                                            className="initial mb-2"
                                            name={item?.consentTxnGroupId}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        previewLang === 'en'
                                                            ? 'This field is required.'
                                                            : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                                },
                                            ]}
                                        >
                                            <Radio.Group>
                                                <Space>
                                                    <Radio
                                                        className={`bg-[#F4F6FC] rounded-lg px-4 py-2`}
                                                        key={`${item.sequence}_Accept`}
                                                        value={true}
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                    >
                                                        {previewLang === 'en'
                                                            ? 'I agree'
                                                            : 'ยินยอม'}
                                                    </Radio>
                                                    <Radio
                                                        className={`bg-[#F4F6FC] rounded-lg px-4 py-2`}
                                                        key={`${item.sequence}_NotAccept`}
                                                        value={false}
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                    >
                                                        {previewLang === 'en'
                                                            ? 'Decline'
                                                            : 'ไม่ยินยอม'}
                                                    </Radio>
                                                </Space>
                                            </Radio.Group>
                                        </Form.Item>
                                    )}
                                </div>
                            )
                        )}
                        <div className="text-sm font-base whitespace-pre-wrap indent-12 my-4">
                            {previewLang === 'en'
                                ? parse(templateDetail?.certificationEn || '')
                                : parse(templateDetail?.certificationTh || '')}
                        </div>
                        {(templateDetail?.contactChannelTh ||
                            templateDetail?.contactChannelEn) && (
                            <div className="my-2">
                                <div className="text-sm font-semibold my-2">
                                    {previewLang === 'en'
                                        ? 'Contact channel'
                                        : 'ช่องทางการติดต่อ'}
                                </div>
                                <div className="text-sm font-base whitespace-pre-wrap leading-6">
                                    {previewLang === 'en'
                                        ? parse(
                                              templateDetail?.contactChannelEn ||
                                                  '-'
                                          )
                                        : parse(
                                              templateDetail?.contactChannelTh ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                        )}

                        <div className="text-sm font-base whitespace-pre-wrap my-4">
                            {templateDetail.effectiveDate &&
                                (previewLang === 'th'
                                    ? `เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ ${toBuddhistYear(
                                          moment(
                                              templateDetail.effectiveDate
                                          ).locale('th'),
                                          'LL'
                                      )}`
                                    : `This document was last updated on ${moment(
                                          templateDetail.effectiveDate
                                      )
                                          .locale('en')
                                          .format('LL')}`)}
                        </div>
                        <div
                            className="my-2"
                            style={{ borderBottom: '1px solid #EDEEF9' }}
                        ></div>
                        <div className="text-sm font-semibold whitespace-pre-wrap">
                            {previewLang === 'en'
                                ? 'Provide consent information as of (date) ...'
                                : 'ให้ข้อมูลความยินยอม ณ วันที่ ...'}{' '}
                        </div>
                        <div
                            hidden={!templateDetail?.isRequireOtp}
                            className="font-semibold space-y-4 mt-4"
                        >
                            <div>
                                {previewLang === 'th'
                                    ? 'กรุณาระบุอีเมลเพื่อยืนยันตัวตนด้วยรหัส OTP (One Time Password)'
                                    : 'Please enter your email address to verify your identity with OTP (One Time Password)'}
                            </div>
                            <div>
                                {previewLang === 'th' ? 'อีเมล' : 'Email'}
                                <div>
                                    <Space>
                                        <Input
                                            className="w-72"
                                            size="large"
                                            placeholder={
                                                previewLang === 'th'
                                                    ? 'ระบุอีเมลเพื่อรับ OTP'
                                                    : 'Enter your email to receive OTP.'
                                            }
                                        />
                                        <Button
                                            type="primary"
                                            size="large"
                                            className="button-link"
                                        >
                                            {previewLang === 'th'
                                                ? 'รับรหัส'
                                                : 'Get OTP'}
                                        </Button>
                                    </Space>
                                </div>
                            </div>
                            <div>
                                {previewLang === 'th'
                                    ? 'ป้อนรหัส OTP (รหัสอ้างอิง: XXXXXX)'
                                    : 'Enter OTP code (Reference code: XXXXXX)'}
                                <div>
                                    <Space>
                                        <Input
                                            className="w-72"
                                            disabled
                                            size="large"
                                        />
                                        <Button
                                            type="primary"
                                            size="large"
                                            className="button-link"
                                        >
                                            {previewLang === 'th'
                                                ? 'ยืนยัน OTP'
                                                : 'Confirm OTP'}
                                        </Button>
                                    </Space>
                                </div>
                            </div>
                        </div>
                        <div className="flex text-center justify-center items-center mt-2">
                            <Form.Item>
                                <Button
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    className="px-9 button-link"
                                >
                                    {previewLang === 'en' ? 'Submit' : 'ยืนยัน'}
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            ) : (
                <div className="bg-white rounded-md whitespace-pre-line border-solid border-[#ECECEC] p-6 mt-2 leading-7 overflow-auto max-h-[700px]">
                    <div className="text-center text-sm space-y-2 my-56">
                        <IconNoData />
                        <p className="text-[#65707A] text-[14px]">
                            {previewLang === 'en' ? 'No Data' : 'ไม่พบข้อมูล'}
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};

export default ConsentPreview;
